import strings from "../values/strings";
import SecureStorage from "secure-web-storage";
import moment from "moment";
import { STATUS } from "./helpers";
import { ROLE_TO_USER_TYPE, UserType, RoleName } from "./roleConstants";
import { adminNavigation } from "./Navs/adminNav";
import { userNavigation } from "./Navs/userNav";

var CryptoJS = require("crypto-js");
var SECRET_KEY = "my secret key";

let Colors = {
  Status: {
    STOLEN: "#cfa17c",
    CHECKEDOUT: "#5D94BA",
    AVAILABLE: "#00c1b1",
    RESERVED: "",
    DAMAGED: "#e6564e",
    LOST: "#1a4784",
    DELETED: "#A4515F",
    UNAVAILABLE: "#bb6bd9",
    OUTOFSERVICES: "#bb6bd9",
    CANCELLED: "#e6564e",
    DELETE: "#777",
    TRANSFER_REQUEST: "#f0ad4e",
    RETURN_REQUEST: "#f0ad4e",
    RETURN: "#777",
    TRANSFERRED: "#777",
  },
};

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  store_item_session: async (key, value) => {
    try {
      await sessionStorage.setItem(key, `${value}`);
    } catch (error) {}
  },
  fetch_item_session: async (key) => sessionStorage.getItem(key),
  remove_item_session: async (key) => {
    try {
      await sessionStorage.removeItem(key);
    } catch (error) {}
  },

  validateMobileno(numericStr) {
    const phoneno = /^[0-9]\d{7,10}$/g;
    if (new RegExp(phoneno).test(numericStr)) {
      return true;
    }
    return false;
  },
  checkStatus(status) {
    switch (status) {
      case -1:
        return "Deactive";
      case 0:
        return "Unavailable";
      case 1:
        return "Active";
      case 2:
        return "Checked out";
      case 5:
        return "Booked";
      case 25:
        return "Returned";
      case 91:
        return "Stolen";
      case 92:
        return "Damaged";
      case 93:
        return "Lost";
      case 99:
        return "Delete";
      case 94: {
        return "Out for service";
      }
      case 97: {
        return "Cancelled";
      }
      case 95: {
        return "DEFULT";
      }
      default: {
        return "Unknown";
      }
    }
  },

  addStatusClass(status) {
    switch (status) {
      case -1:
        return "damage";
      case 0:
        return "out-of-service";
      case 1:
        return "available";
      case 2:
        return "chek-out";
      case 5:
        return "out-of-service";
      case 91:
        return "stolen";
      case 92:
        return "damage";
      case 93:
        return "lost";
      case 99:
        return "damage";
      case 94:
        return "out-of-service";
    }
  },
  validateSpace(value) {
    const spaceRegex = new RegExp("\\s");
    return spaceRegex.test(value);
  },
  validateNumber(number) {
    const numberFormet = /^[0-9]{7,10}$/;
    return numberFormet.test(number);
  },
  validateEmail(email) {
    const regex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
  },
  stringHasSpecialChars(str) {
    const regex = /^[a-zA-Z0-9 ]*$/;
    return regex.test(str);
  },
  validateString(string) {
    return !/\d/.test(string);
  },
  validateMobileEmail(str) {
    const phoneno = /^[0-9]{7,10}$/;
    const regex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (new RegExp(phoneno).test(str)) {
      return true;
    } else if (str.match(regex)) {
      return true;
    } else {
      return false;
    }
  },
  onlyNumericAllowed(str) {
    const regex = /^[0-9]+$/;
    return regex.test(str);
  },
  validateLoginForm(formData) {
    const iterator = Object.keys(formData);
    let error = false;
    if (iterator.length > 0) {
      const validationArr = [];
      for (let index = 0; index < iterator.length; index++) {
        if (formData[iterator[index]] === undefined) {
          formData[iterator[index]] = "";
        }
        if (formData[iterator[index]].required) {
          if (
            formData[iterator[index]].value !== undefined &&
            formData[iterator[index]].value !== "" &&
            formData[iterator[index]].value !== null &&
            `${formData[iterator[index]].value}`.trim() !== ""
          ) {
            if (formData[iterator[index]].propname === "email") {
              if (!this.validateMobileEmail(formData[iterator[index]].value)) {
                formData[iterator[index]].err = true;
                formData[iterator[index]].errMsg =
                  strings.errors.validEmailMobileError;
              } else {
                formData[iterator[index]].err = false;
                formData[iterator[index]].errMsg = "";
              }
            }
            if (formData[iterator[index]].propname === "password") {
              if (this.validateSpace(formData[iterator[index]].value)) {
                formData[iterator[index]].err = true;
                formData[iterator[index]].errMsg = strings.errors.noSpace;
              } else {
                formData[iterator[index]].err = false;
                formData[iterator[index]].errMsg = "";
              }
            }
          } else {
            formData[iterator[index]].err = true;
            formData[iterator[index]].errMsg = strings.errors.requiredField;
          }
        } else {
          formData[iterator[index]].err = false;
          formData[iterator[index]].errMsg = "";
        }
        validationArr.push(formData[iterator[index]].err);
      }

      if (validationArr.indexOf(true) !== -1) {
        error = true;
      } else {
        error = false;
      }
    } else {
      error = true;
    }
    return new Promise((resolve) => {
      resolve({ error, formDataObj: formData });
    });
  },
  validateForm(formData) {
    let iterator = Object.keys(formData);
    let isArray = false;
    if (Array.isArray(formData)) {
      iterator = formData;
      isArray = true;
    }

    let error = false;
    if (iterator.length > 0) {
      const validationArr = [];
      iterator.forEach((item) => {
        let field = item;
        if (!isArray) {
          //then formData is an object, not an array
          field = formData[item];
        }

        // if object is required
        if (field.required) {
          // if object.value exists
          if (
            field.value !== undefined &&
            field.value !== "" &&
            field.value !== null &&
            `${field.value}`.trim() !== ""
          ) {
            // go through specific validations beyond existence
            if (field.propname === "username") {
              if (this.validateSpace(field.value)) {
                field.err = true;
                field.errMsg = strings.errors.noSpace;
              } else if (!this.validateString(field.value)) {
                field.err = true;
                field.errMsg = strings.errors.onlyAlphabatesAlowed;
              } else if (!this.stringHasSpecialChars(field.value)) {
                field.err = true;
                field.errMsg = strings.errors.specialCharacterNotAllowed;
              } else {
                field.err = false;
                field.errMsg = "";
              }
            }
            if (field.propname === "empId") {
              if (this.stringHasSpecialChars(field.value)) {
                field.err = false;
                field.errMsg = "";
              } else {
                field.err = true;
                field.errMsg = strings.errors.specialCharacterNotAllowed;
              }
            } else if (
              field.propname === "mobileNumber" ||
              field.propname === "mobileNo"
            ) {
              if (!this.validateMobileno(field.value)) {
                field.err = true;
                field.errMsg = strings.errors.enterValidMobileno;
              } else {
                field.err = false;
                field.errMsg = "";
              }
            } else if (field.propname === "email") {
              if (!this.validateEmail(field.value)) {
                field.err = true;
                field.errMsg = strings.errors.validEmailError;
              } else {
                field.err = false;
                field.errMsg = "";
              }
            } else if (
              field.propname === "password" ||
              field.propname === "confirmPassword" ||
              field.propname === "oldPassword" ||
              field.propname === "newPassword" ||
              field.propname === "repeatPassword"
            ) {
              if (field.value.length < 6) {
                field.err = true;
                field.errMsg = strings.errors.Max_Limit;
              } else if (this.validateSpace(field.value)) {
                field.err = true;
                field.errMsg = strings.errors.noSpace;
              } else if (field.propname === "confirmPassword") {
                let firstPassword;
                if (isArray) {
                  const passwordObj = formData.find(
                    (item) => item.propname === "password",
                  );
                  firstPassword = passwordObj?.value;
                } else {
                  firstPassword = formData.password.value;
                }
                if (field.value === firstPassword) {
                  field.err = false;
                  field.errMsg = "";
                } else {
                  field.err = true;
                  field.errMsg = strings.errors.MatchPass;
                }
              } else {
                field.err = false;
                field.errMsg = "";
              }
            } else if (field.propname === "number") {
              if (!this.onlyNumericAllowed(field.value)) {
                field.err = true;
                field.errMsg = strings.errors.numericOnly;
              }
            }
          } else {
            // object.value doesn't exist in required field, so error
            field.err = true;
            field.errMsg = strings.errors.requiredField;
          }
        } else {
          // object.value is not required, so no error
          field.err = false;
          field.errMsg = "";
        }
        // add error boolean to array
        validationArr.push(field.err);
      });
      if (validationArr.indexOf(true) !== -1) {
        error = true;
      } else {
        error = false;
      }
    } else {
      // object is empty
      error = true;
    }
    // formData contains updated error boolean and errMsg
    return new Promise((resolve) => {
      resolve({ error, formDataObj: formData });
    });
  },
  processData: (data) => {
    const sundriesObj = {};
    const processedData = {};
    if (Array.isArray(data)) {
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        processedData[element.propname] = element.val;
      }
    } else {
      Object.keys(data).map((item) => {
        if (data[item].element === "image") {
          const tempArray = [];
          if (data[item].value[0].id) {
            const { id } = data[item].value[0];
            const obj = {};
            obj[id] = "No notes available";
            tempArray.push(obj);
            processedData[item] = obj;
          }
        } else if (
          item === "deutschPlugQuantity" ||
          item === "conduitLength" ||
          item === "3CoreLength" ||
          item === "2CoreLength"
        ) {
          sundriesObj[data[item].sundries_id] = data[item].value;
          processedData.sundries = sundriesObj;
        } else {
          processedData[item] = data[item].value;
        }
      });
    }
    return processedData;
  },
  getMasterDataList(ListItem, masterData) {
    if (ListItem.options) {
      Object.keys(masterData.MasterData.data).map((item, index) => {
        if (ListItem.propname === item) {
          const singleArrayItem = masterData.MasterData.data[item];
          singleArrayItem.map((innerItem, index) => {
            const dataKey = Object.values(innerItem);
            innerItem.value = dataKey[0];
            if (ListItem.propname === "equipmentType") {
              innerItem.label = `${dataKey[0]}`;
            } else {
              innerItem.label = `${dataKey[1]}`;
            }
          });
          ListItem.options = singleArrayItem;
        }
      });
      return ListItem.options;
    }
    return ListItem.options;
  },
  actionOnObject(object, action) {
    switch (action) {
      case "delete":
      case 1:
      default:
        return object;
    }
  },
  getCurrentDateAndTime() {
    const today = new Date();
    const date = `${today.getFullYear()}-${
      (today.getMonth() > 8 ? today.getMonth() : `0${today.getMonth()}`) + 1
    }-${today.getDate() > 9 ? today.getDate() : `0${today.getDate()}`}`;
    const time = `${today.getHours()}:${
      today.getMinutes() > 9 ? today.getMinutes() : `0${today.getMinutes()}`
    }:${
      today.getSeconds() > 9 ? today.getSeconds() : `0${today.getSeconds()}`
    }`;
    const dateTime = `${date} ${time}`;
    return dateTime;
  },
  miliSecondsToTime(duration) {
    const milliseconds = parseInt((duration % 1000) / 100);
    let seconds = Math.floor((duration / 1000) % 60);
    let minutes = Math.floor((duration / (1000 * 60)) % 60);
    let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

    hours = hours < 10 ? `0${hours}` : hours;
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    seconds = seconds < 10 ? `0${seconds}` : seconds;
    return `${hours}:${minutes}:${seconds}.${milliseconds}`;
  },
  miliSecondsToSeconds(duration) {
    const seconds = Math.floor(duration / 1000);
    return seconds;
  },
  SecureStorageFunc: (data, type, value = "") => {
    var secureStorage = new SecureStorage(localStorage, {
      hash: function hash(key) {
        key = CryptoJS.SHA256(key, SECRET_KEY);

        return key.toString();
      },
      encrypt: function encrypt(data) {
        data = CryptoJS.AES.encrypt(data, SECRET_KEY);

        data = data.toString();

        return data;
      },
      decrypt: function decrypt(data) {
        data = CryptoJS.AES.decrypt(data, SECRET_KEY);

        data = data.toString(CryptoJS.enc.Utf8);

        return data;
      },
    });
    if (type === "set") {
      secureStorage.setItem(data, value);
      return true;
    } else if (type === "get") {
      var decryptedData = secureStorage.getItem(data);
      return decryptedData;
    } else if (type === "clear") {
      secureStorage.clear();
    }
  },
  getStoredUserData() {
    const storedUserDataString = this.SecureStorageFunc("userData", "get", "");
    if (storedUserDataString == null || storedUserDataString === "")
      return null;
    if (typeof storedUserDataString === "string") {
      try {
        return JSON.parse(storedUserDataString);
      } catch (parseError) {
        console.warn(
          "getStoredUserData: failed to parse userData from storage",
          parseError,
        );
        throw new Error("Failed to parse stored user data", {
          cause: parseError,
        });
      }
    }
    return storedUserDataString;
  },
  getStoredUserTypeLabel() {
    try {
      const data = this.getStoredUserData();
      const userTypeLabel = data?.userType || data?.user?.userType || "";
      console.log("getStoredUserTypeLabel", { userTypeLabel });
      return userTypeLabel;
    } catch {
      return "";
    }
  },

  isAdminRoleName(roleName) {
    if (!roleName || typeof roleName !== "string") return false;
    const userRole = roleName.trim();
    if (userRole === RoleName.ASSET_ADMIN || userRole === RoleName.TOOL_ADMIN) {
      console.log(`The user role is an admin`, { userRole });
      return true;
    }
    console.log(`The user role is a non admin`, { userRole });
    return false;
  },

  isAdminOrMasterRoleName(roleName) {
    if (!roleName || typeof roleName !== "string") return false;
    const userRole = roleName.trim();
    if (
      userRole === RoleName.ASSET_ADMIN ||
      userRole === RoleName.TOOL_ADMIN ||
      userRole === RoleName.ASSET_MASTER ||
      userRole === RoleName.TOOL_MASTER
    ) {
      console.log(`The user role is an admin/master`, { userRole });
      return true;
    }
    console.log(`The user role is a non admin/master`, { userRole });
    return false;
  },

  getEffectiveUserTypeFromRoleId(roleId, roles = []) {
    if (!roleId || !Array.isArray(roles) || roles.length === 0) return "";
    const role = roles.find((role) => role._id === roleId);
    if (!role?.name) return "";
    return ROLE_TO_USER_TYPE[role.name] ?? "";
  },
  getEffectiveUserType(userType, userTypeLabel = "", roleId = null) {
    if (userType === UserType.ADMIN || userType === UserType.MASTER)
      return userType;
    const roles = globalThis.masters?.roles ?? [];
    const fromRoleId = this.getEffectiveUserTypeFromRoleId(roleId, roles);
    if (fromRoleId) return fromRoleId;
    const typeFromLabel = ROLE_TO_USER_TYPE[userTypeLabel];
    if (typeFromLabel) return typeFromLabel;
    return userType || "";
  },
  getPluralLabel(value) {
    switch (value) {
      case "Booking":
      case "Checkout":
      case "Reservation":
      case "Request":
      case "Transfer":
      case "Return":
        return `${value}s`;
      default:
        return value;
    }
  },
  checkBookingStatus(status) {
    switch (status) {
      case -1:
        return "Deactive";
      case 0:
        return "Pending";
      case 1:
        return "Checked out";
      case 25:
        return "Returned";
      case 31:
        return "Transferred";
      case 32:
        return "Transfer request";
      case 41:
        return "Returned";
      case 42:
        return "Returned - Validation Pending";
      case 91:
        return "Stolen";
      case 92:
        return "Damaged";
      case 93:
        return "Lost";
      case 99:
        return "Delete";
      case 94:
        return "Out for service";
      case 95:
        return "Delete Request Pending";
    }
  },

  getToolStatus(mStatus) {
    switch (mStatus) {
      case STATUS.TOOL.UNAVAILABLE:
        return "Unavailable";
      case STATUS.TOOL.ACTIVE:
        return "Available";
      case STATUS.TOOL.CHECKEDOUT:
        return "Checked out";
      case STATUS.TOOL.BOOKED:
        return "Reserved";
      case STATUS.TOOL.STOLEN:
        return "Stolen";
      case STATUS.TOOL.DAMAGED:
        return "Damaged";
      case STATUS.TOOL.LOST:
        return "Lost";
      case STATUS.TOOL.DELETE:
        return "Deleted";
      case STATUS.TOOL.CANCELLED:
        return "Cancelled";
      case STATUS.TOOL.OUTOFSERVICES:
        return "Out for service";
      case STATUS.TOOL.RETURN_REQUEST:
      case STATUS.TOOL.RETURN_PENDING:
        return "Returned - Validation Pending";
      case STATUS.TOOL.TRANSFER_PENDING:
        return "Transfer in Progress";
      case STATUS.TOOL.REQUESTDELETEPENDDING:
        return "Del. requested";
      default:
        return "";
    }
  },
  getReturnOnDuration(value) {
    var ms = moment(moment(value), "DD/MM/YYYY HH:mm:ss").diff(
      moment(new Date(), "DD/MM/YYYY HH:mm:ss"),
    );
    var d = moment.duration(ms);
    if (d.minutes() > 0) {
      return d.years() > 0
        ? ``
        : `(${
            d.months() > 0
              ? d.months() + `${d.months() > 1 ? " months " : " month "}`
              : ""
          }${
            d.days() > 0
              ? d.days() + `${d.days() > 1 ? " days " : " day "}`
              : ""
          }${
            d.hours() > 0
              ? d.hours() < 10
                ? "0" + d.hours()
                : d.hours()
              : "00"
          }:${
            d.minutes() > 0
              ? d.minutes() < 10
                ? "0" + d.minutes()
                : d.minutes()
              : "00"
          } hrs)`;
    } else {
      return `(${
        Math.abs(d.months()) > 0
          ? `${Math.abs(d.months()) < 10 ? "0" : ""}${Math.abs(d.months())}` +
            `${Math.abs(d.months()) > 1 ? " months " : " month "}`
          : ""
      }${Math.abs(d.days()) < 10 && Math.abs(d.days()) > 0 ? "0" : ""}${
        Math.abs(d.days()) > 0
          ? Math.abs(d.days()) +
            `${Math.abs(d.days()) > 1 ? " days " : " day "}`
          : ""
      }${Math.abs(d.hours()) < 10 ? "0" : ""}${Math.abs(d.hours()) + ":"}${
        Math.abs(d.minutes()) < 10 ? "0" : ""
      }${Math.abs(d.minutes()) + " hrs"} passed)`;
    }
  },

  getReserveValid(value) {
    var hours = moment(value).diff(moment(new Date()), "hours");
    var minutes = moment(value).diff(moment(new Date()), "minutes") % 60;

    if (minutes > 0) {
      return `(${hours < 10 ? "0" + hours : hours}:${
        minutes < 10 ? "0" + minutes : minutes
      } hrs)`;
    } else {
      return `(${
        Math.abs(hours) < 10 ? "0" + Math.abs(hours) : Math.abs(hours)
      }:${
        Math.abs(minutes) < 10 ? "0" + Math.abs(minutes) : Math.abs(minutes)
      } hrs)`;
    }
  },

  getKeyCount(items, key) {
    if (items && items.length) {
      return items.reduce((value, item) => {
        return value + item[key];
      }, 0);
    }

    return 0;
  },
  getBookingStatusClass(status) {
    switch (status) {
      case -1:
        return "damage";
      case 0:
        return "out-of-service";
      case 1:
        return "available";
      case 2:
        return "chek-out";
      case 31:
        return "status-gray";
      case 32:
      case 19:
      case 17:
        return "status-yellow";
      case 41:
        return "status-gray";
      case 42:
        return "status-yellow";
      case 5:
        return "out-of-service";
      case 91:
        return "damage";
      case 92:
        return "damage";
      case 93:
        return "lost";
      case 94:
        return "out-of-service";
      case 95:
        return "Del. requested";
      case 99:
        return "damage";
    }
  },
  checkRequestStatus(status) {
    switch (status) {
      case 0:
        return "Pending";
      case 1:
        return "Approved";
      case 97:
        return "Cancelled";
      case 98:
        return "Declined";
      default:
        return "N/A";
    }
  },

  getStatusClass(status, group) {
    if (group === "request") {
      switch (status) {
        case 0:
          return "status-yellow";
        case 1:
          return "status-green";
        case 97:
          return "status-gray";
        case 98:
          return "status-gray";
        default:
          return "status-gray";
      }
    }
  },
  validateFormField(obj, value) {
    if (obj.required || value) {
      if (value === "") {
        obj = {
          ...obj,
          err: true,
          errMsg: "This field is required.",
          value: value,
        };
      } else if (obj.min && value.toString().length < obj.min) {
        obj = {
          ...obj,
          err: true,
          errMsg: "Value is too short.",
          value: value,
        };
      } else if (obj.textType && obj.textType === "text" && !isNaN(value)) {
        obj = {
          ...obj,
          err: true,
          errMsg: strings.errors.onlyAlphabatesAlowed,
          value: value,
        };
      } else if (obj.textType && obj.textType === "integer" && isNaN(value)) {
        obj = {
          ...obj,
          err: true,
          errMsg: strings.errors.numericOnly,
          value: value,
        };
      } else {
        obj = { ...obj, err: false, errMsg: "", value: value };
      }
      return obj;
    } else {
      obj = { ...obj, err: false, errMsg: "", value: value };
    }
    return obj;
  },

  // {organisationName: {required: true, err: false, errMsg: "", value: 'kjdslkf'}, prefix: {}}
  prepareSubOrgForFilterData(subOrgList) {
    let subOrgFilters = subOrgList.map((item) => {
      return {
        id: item._id,
        value: item._id,
        label: item.name + " (Sub)",
      };
    });
    // add filter by parent org only to list, if parent has suborgs
    if (subOrgList.length) {
      subOrgFilters = [
        {
          id: "nosuborg",
          value: "nosuborg",
          label: subOrgList[0].organisationName,
        },
        ...subOrgFilters,
      ];
    }
    return subOrgFilters;
  },
  convertTagToString(sequences, prefix) {
    let tagString = sequences.reduce((tagString, sequence) => {
      if (sequence[0] === sequence[1]) {
        tagString += `${prefix}${sequence[0]}, `;
      } else {
        tagString += `${prefix}${sequence[0]} - ${prefix}${sequence[1]}, `;
      }
      return tagString;
    }, "");
    //remove last comma
    return tagString.slice(0, -2);
  },
};

export const aggregateTotalAssetsbyCategory = (data) => {
  const aggregated = {};

  data.forEach((tool) => {
    aggregated[tool?.toolId] = {
      Category: tool?.toolName,
      totalAssets: tool?.quantity,
    };
  });

  return Object.values(aggregated);
};

export const aggregateBookingsByCategory = (bookingsData, toolCategories) => {
  const categoryMap = toolCategories.reduce((acc, category) => {
    acc[category._id] = category.name;
    return acc;
  }, {});

  const toolAggregation = {};

  bookingsData.forEach((booking) => {
    if (Array.isArray(booking.tools)) {
      booking.tools.forEach((tool) => {
        const toolId = tool.toolId.toString();
        const totalAssets = tool.quantity || 0;
        const Category = categoryMap[toolId] || "Unknown";

        if (!toolAggregation[toolId]) {
          toolAggregation[toolId] = { Category, totalAssets: 0 };
        }

        toolAggregation[toolId].totalAssets += totalAssets;
      });
    }
  });

  return Object.values(toolAggregation);
};

export const aggregateAvailableAssetsbyCategory = (data) => {
  const aggregated = {};

  data.forEach((tool) => {
    aggregated[tool?.toolId] = {
      Category: tool?.toolName,
      totalAssets: tool?.avlQuantity,
    };
  });

  return Object.values(aggregated);
};
export const aggregateIndividualAssetDatabyCategory = (data) => {
  const aggregated = {};

  data.forEach((tool) => {
    if (aggregated[tool?.toolId]) {
      aggregated[tool?.toolId]["totalAssets"] += 1;
    } else {
      aggregated[tool?.toolId] = {
        Category: tool?.toolName,
        totalAssets: 1,
      };
    }
  });

  return Object.values(aggregated);
};

export const HEADER_TITLE_OVERRIDES = {
  "/dashboard": "KPI Dashboard",
};

export const getHeaderTitle = (pathname, userType) => {
  const isAdminOrMaster =
    userType === UserType.ADMIN || userType === UserType.MASTER;
  const navigationItems = isAdminOrMaster
    ? adminNavigation.items
    : userNavigation.items;
  if (HEADER_TITLE_OVERRIDES[pathname]) {
    return HEADER_TITLE_OVERRIDES[pathname];
  }
  const navigationItemsSortedByPathLength = [...navigationItems].sort(
    (firstItem, secondItem) =>
      (secondItem.url?.length ?? 0) - (firstItem.url?.length ?? 0),
  );
  const matchedNavItem = navigationItemsSortedByPathLength.find((navItem) => {
    const itemUrl = navItem.url || "";
    const firstPathSegment = itemUrl.split("/").find(Boolean);
    const basePathPrefix = firstPathSegment ? `/${firstPathSegment}` : itemUrl;
    return (
      pathname === itemUrl ||
      pathname.startsWith(itemUrl + "/") ||
      pathname === basePathPrefix ||
      pathname.startsWith(basePathPrefix + "/")
    );
  });
  return matchedNavItem?.name ?? "";
};

export const mapDropdownData = (data) => {
  return data.map((item) => ({
    _id: item.id || item._id,
    value: item.value,
    name: item.name || item.label,
  }));
};
